import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { Subscription } from 'rxjs';
import { PatientService } from '../../modules/shared/services/patient/patient.service';

@Component({
  selector: 'formly-patient-search',
  template: `
    <div class="form-group">
      <label>Patient: *</label>
      <p-autoComplete
        [suggestions]="results"
        (completeMethod)="getSearchResults($event)"
        [formControl]="formControl"
        [formlyAttributes]="field"
        field="firstName"
        [forceSelection]="true"
        [placeholder]="'Search patient by name or patientId e.g. John'"
        [showEmptyMessage]="true"
        [emptyMessage]="'No patient found. Try typing full name.'"
        [required]="true"
      >

        <ng-template let-patient pTemplate="item">
          {{patient?.firstName}} {{patient?.lastName}} - {{patient?.patientId}}
        </ng-template>

      </p-autoComplete>
    </div>
  `,
})
export class PatientSearchInputFieldComponent extends FieldType {

  subscriptions = new Subscription();
  results: any[];
  rows = 100;

  defaultPagination = {
    page: 0,
    pageSize: this.rows,
    searchParam: null,
  };

  constructor(
    private patientService: PatientService
  ) {
    super();
  }

  getSearchResults(event): void {
    let searchText = event.query;
    if (searchText) {
      this.defaultPagination = {
        ...this.defaultPagination,
        searchParam: searchText,
      };
    }
    this.getPaginatedPatients();
  }

  getPaginatedPatients(): void {
      this.subscriptions.add(
        this.patientService
        .getPaginatedPatients(this.defaultPagination)
          .subscribe({
            next: (res) => {
              this.results = res.result;
            }
          })
      );
  }
}
